import { useState } from "react";

interface Props {
  handleAddScore: (scoreToAdd: number, isChecked: boolean) => void;
  answer: string;
  index: string;
  isValide: boolean;
  value: boolean;
}

const CheckBox: React.FC<Props> = ({
  handleAddScore,
  answer,
  index,
  isValide,
  value,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(value);

  const handleChechBoxChange = () => {
    handleAddScore(isValide === !isChecked ? 1 : -1, !isChecked);
    setIsChecked((old) => !old);
  };
  return (
    <div
      style={{
        marginTop: "10px",
        display: "flex",
        width: "100%",
      }}
      className="ion-justify-content-center ion-align-items-center btn btn-resp no-bold"
    >
      <input
        checked={isChecked ?? false}
        onChange={handleChechBoxChange}
        type="checkbox"
        id={index}
        style={{
          width: "25px",
          height: "25px",
          marginLeft: "10px",
        }}
        name="horns"
      />
      <label
        htmlFor={index}
        style={{
          width: "100%",
          textAlign: "center",
          color : "black"
        }}
        className="ion-align-items-center ion-justify-content-center input-padding"
      >
        {answer}
      </label>
    </div>
  );
};

export default CheckBox;
